window.actualizarTablaPersonal = null;

if (window.location.href.includes("personal")) {

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#tablaPersonal tbody");
    const filtroNombre = document.getElementById("filtroNombre");
    const filtroArea = document.getElementById("filtroArea");
    const filtroRol = document.getElementById("filtroRol");
    const filtroCargo = document.getElementById("filtroCargo");

    if (tableBody && filtroNombre && filtroArea && filtroRol && filtroCargo) {

        let cargando = false;
        let timeoutFiltro = null;

        window.actualizarTablaPersonal = async () => {

            if (cargando) return;
            if (document.hidden) return;

            cargando = true;

            const nombre = filtroNombre.value;
            const area = filtroArea.value;
            const rol = filtroRol.value;
            const cargo = filtroCargo.value;

            const url = `/api/personal?filtroNombre=${nombre}&filtroArea=${area}&filtroRol=${rol}&filtroCargo=${cargo}`;

            try {

                const response = await fetch(url, requestOptions);

                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                const result = await response.json();
                const data = result.result;

                tableBody.innerHTML = "";

                if (!data || !data.resultado || data.resultado.length === 0) {

                    const row = document.createElement("tr");
                    row.classList.add("no-data");

                    row.innerHTML = `
                        <td colspan="5">
                            <div class="cont-no-data">
                                No se encontró información.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>
                    `;

                    tableBody.appendChild(row);
                    return;
                }

                const v = Date.now();
                data.resultado.forEach(function (item) {
                    const textoEstado = Number(item.estado) === 1 ? 'ACTIVO' : 'INACTIVO';
                    const classEstado = Number(item.estado) === 1 ? 'tdVerde' : 'tdGris';
                    const row = document.createElement("tr");

                    row.innerHTML = `
                        <td>
                            <div class="contPersona">
                                <div class="cardPersonalAvatar">
                                    <img class="imgColaborador" src="/public/uploads/usuarios/${item.fotoUsuario}?v=${v}" alt="colaborador">
                                </div>
                                <span>${item.nombreCompletoUsuario}</span>
                            </div>
                        </td>
                        <td>${item.nombreCargo}</td>
                        <td>${item.nombreArea}</td>
                        <td>${item.nombreRol}</td>
                        <td>${item.nombreZona}</td>
                        <td>
                            <div class="${classEstado}">
                                <span>${textoEstado}</span>
                            </div>
                        </td>
                        <td>
                            <button id="btnModalEditarPersonal" class="btnVerReporte btnTabla btnModal" data-id="${item.idUsuario}" data-modal="modalEditarPersonal">
                                <img src="/public/build/img/icons/editar.svg" alt="editar">
                            </button>
                        </td>
                    `;

                    tableBody.appendChild(row);
                });

            } catch (error) {

                console.error("Error en tabla personal:", error);

                if (typeof lanzarAlerta === "function") {
                    lanzarAlerta("No se pudo actualizar la tabla personal.", "alerta-roja");
                }

            } finally {
                cargando = false;
            }
        };

        function actualizarConDebounce() {

            clearTimeout(timeoutFiltro);

            timeoutFiltro = setTimeout(function () {
                window.actualizarTablaPersonal();
            }, 400);
        }

        filtroNombre.addEventListener("input", actualizarConDebounce);
        filtroArea.addEventListener("input", actualizarConDebounce);
        filtroRol.addEventListener("input", actualizarConDebounce);
        filtroCargo.addEventListener("input", actualizarConDebounce);

        window.actualizarTablaPersonal();

        setInterval(function () {
            window.actualizarTablaPersonal();
        }, 120000);
    }
}